import { DefaultService } from '@/services/DefaultService';

export default class RelatorioVenRotasService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    load(dataRota, vendedores) {
        return  this._http.get(`${this._env}/report/sales/routes.json?data=${dataRota}&vendedores=${vendedores.join(',')}`, this._headers)
                    .then(res => res.body, this.handleError);
    }

}